import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";

const FORM_SLUG = "youber-music";
const ORG_ID = "1";
const API_BASE = "https://api.youber.net";
const SCRIPT_SRC = "https://cdn.jsdelivr.net/gh/samanmohamadi/finodex-form-embed@v0.1.0/dist/finodex-forms.js";

function ensureFinodexScript() {
  if (typeof window === "undefined") return Promise.resolve();
  if (window.__finodexLoaded) return Promise.resolve();

  if (window.__finodexLoading) return window.__finodexLoading;

  window.__finodexLoading = new Promise((resolve) => {
    const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
    if (existing) {
      existing.addEventListener("load", () => {
        window.__finodexLoaded = true;
        resolve();
      });
      return;
    }
    const s = document.createElement("script");
    s.src = SCRIPT_SRC;
    s.async = true;
    s.onload = () => {
      window.__finodexLoaded = true;
      resolve();
    };
    document.body.appendChild(s);
  });

  return window.__finodexLoading;
}

export default function RegistrationForm() {
  const containerRef = useRef(null);
  const renderedRef = useRef(false);

  useEffect(() => {
    let cancelled = false;
    ensureFinodexScript().then(() => {
      if (cancelled || renderedRef.current || !containerRef.current) return;
      if (window.FinodexForms?.render) {
        window.FinodexForms.render({
          container: containerRef.current,
          slug: FORM_SLUG,
          orgId: Number(ORG_ID),
          apiBase: API_BASE,
          submitLabel: "ارسال درخواست بررسی",
        });
        renderedRef.current = true;
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section id="register" className="py-20 md:py-28 relative">
      <div className="absolute -top-24 right-1/4 w-[28rem] h-[28rem] bg-purple-600/20 blur-[140px] rounded-full pointer-events-none" />
      <div className="absolute -bottom-24 left-1/4 w-[28rem] h-[28rem] bg-cyan-500/15 blur-[140px] rounded-full pointer-events-none" />

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight">
            درخواست <span className="gradient-text-neon">انتشار یا نقد کردن</span> درآمد
          </h2>
          <p className="mt-4 text-slate-300 leading-relaxed max-w-2xl mx-auto">
            فرم زیر را تکمیل کنید تا تیم ما شرایط اثر، هزینه، زمان‌بندی انتشار و مسیر دریافت درآمد را بررسی کند و با شما تماس بگیرد.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.1 }}
          transition={{ duration: 0.6 }}
          className="glass rounded-[2rem] p-6 md:p-10 finodex-wrapper"
          data-testid="registration-form-wrapper"
        >
          <div
            ref={containerRef}
            data-finodex-form={FORM_SLUG}
            data-finodex-org={ORG_ID}
            data-finodex-api={API_BASE}
            data-testid="finodex-form-container"
          />
        </motion.div>
      </div>
    </section>
  );
}
